import { render, staticRenderFns } from "./ContentTypeBoxes.vue?vue&type=template&id=72f8994c&scoped=true&"
import script from "./ContentTypeBoxes.vue?vue&type=script&lang=js&"
export * from "./ContentTypeBoxes.vue?vue&type=script&lang=js&"
import style0 from "./ContentTypeBoxes.vue?vue&type=style&index=0&id=72f8994c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f8994c",
  null
  
)

export default component.exports